module.exports = __webpack_public_path__ + "workspace/static/img/downloadSignatureOne.5a447ed.png";